import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const BookCall = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  // EmailJS Configuration
  // Replace with your EmailJS dashboard values:
  const EMAILJS_SERVICE_ID = 'service_0s5th9i';      // e.g. 'service_abc123'
  const EMAILJS_TEMPLATE_ID = 'template_k12j3up';    // e.g. 'template_xyz789'
  const EMAILJS_PUBLIC_KEY = 'sXQkPFULJkdynKDbb';      // Find in Account > API Keys

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Form validation function
  const validateForm = () => {
    // Name validation (min 3 characters)
    if (formData.name.trim().length < 3) {
      alert('Ime mora imati barem 3 karaktera!');
      return false;
    }

    // Email validation
    if (!validateEmail(formData.email)) {
      alert('Molimo unesite validnu email adresu!');
      return false;
    }

    // Message validation (min 10 characters)
    if (formData.message.trim().length < 10) {
      alert('Poruka mora imati barem 10 karaktera!');
      return false;
    }

    return true;
  };

  // Handle form changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      // Send email via EmailJS
      const result = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          name: formData.name,
          email: formData.email,
          company: formData.company || 'N/A',
          message: formData.message,
          to_email: 'office@eagleaiagents.com' // Recipient email
        },
        EMAILJS_PUBLIC_KEY
      );

      console.log('Email successfully sent:', result.text);
      alert('Hvala vam! Kontaktiraćemo vas uskoro.');

      // Reset form
      setFormData({
        name: '',
        email: '',
        company: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Došlo je do greške prilikom slanja poruke. Molimo pokušajte ponovo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="kontakt" className="py-20 bg-gray-900/50">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Zakaži besplatan audit</h2>
          <p className="text-xl text-gray-300">
            Otkrij kako možemo automatizovati tvoj inbox i povećati prodaju u narednih 14 dana.
          </p>
        </div>

        <div className="bg-black rounded-lg p-8 border border-gray-800">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Ime i prezime * <span className="text-xs text-gray-500">(min 3 karaktera)</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
                  placeholder="Unesite vaše ime i prezime"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Email adresa *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
                  placeholder="name@company.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Naziv firme / Profila <span className="text-xs text-gray-500">(opciono)</span>
              </label>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
                placeholder="Naziv vašeg brenda"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Poruka * <span className="text-xs text-gray-500">(min 10 karaktera)</span>
              </label>
              <textarea
                name="message"
                rows={5}
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
                placeholder="Opiši svoj biznis i trenutne izazove sa inboxom..."
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors text-lg disabled:bg-gray-600 disabled:cursor-not-allowed"
            >
              {loading ? 'Slanje...' : 'Zakaži besplatan audit'}
            </button>

          </form>
        </div>
      </div>
    </section>
  );
};

export default BookCall;